export const gendersList = [
	{ NAME: 'Masculino', VALUE: 'Male' },
	{ NAME: 'Femenino', VALUE: 'Female' },
];

export const gendersTypes = gendersList.reduce((acc, item) => {
	acc[item.NAME] = item.VALUE;
	return acc;
}, {});
